import type { Action, ThunkAction } from '@reduxjs/toolkit';
import { configureStore } from '@reduxjs/toolkit';

import rootReducer, { RootState } from './rootReducers';

export const store = configureStore({
  reducer: rootReducer,
  devTools: true,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type AppState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  AppState,
  unknown,
  Action<string>
>;

export const getServerStore = () =>
  configureStore({
    reducer: rootReducer,
  });

let clientStore: ReturnType<typeof getServerStore>;

export const getClientStore = (preloadedState?: RootState, newStore = false) => {
  if (newStore)
    return configureStore({
      reducer: rootReducer,
      preloadedState,
    });
  if (!clientStore)
    clientStore = configureStore({
      reducer: rootReducer,
      preloadedState,
    });
  return clientStore;
};

export * from './edit';
export * from './global';
export * from './hooks';
export * from './user';
export * from './home';
export * from './imageLibrary';
export * from './mirror';
export * from './fm';
